import { FormProvider } from 'react-hook-form';
import { Box, styled } from '@mui/material';
import { LWModal } from 'redesign';
import { DocumentSignDialogContentProps } from './document-sign-dialog-content.types';
import { SignDocumentDialogHeader } from './components/sign-document-dialog-header/sign-document-dialog-header';
import { Buttons } from './components/buttons';
import { SignDocumentDialogBody } from './components/sign-document-dialog-body/sign-document-dialog-body';
import { useDocumentDialogSign } from '../../../table/hooks/use-document-dialog-sign';

export const DocumentSignDialogContent = ({
  isOpen,
  onClose,
  documentId,
  documentData,
}: DocumentSignDialogContentProps) => {
  const { firstName, lastName, infix, phone, email, status, type } = documentData;
  const { methods, handleSubmit } = useDocumentDialogSign(
    documentId,
    onClose,
    documentData.formDataModel
  );

  return (
    <LWModal isOpen={isOpen} onClose={onClose}>
      <DialogLayout>
        <SignDocumentDialogHeader
          onClose={onClose}
          firstName={firstName}
          lastName={lastName}
          infix={infix}
          phoneNumber={phone}
          email={email}
        />
        <FormProvider {...methods}>
          <SignDocumentDialogBody
            selectedDocumentModel={documentData.formDataModel['actions']['issuer_sign']}
            type={type}
            status={status}
          />
          <Buttons onCancel={onClose} onSubmit={handleSubmit} />
        </FormProvider>
      </DialogLayout>
    </LWModal>
  );
};

const DialogLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(8),
  height: '100%',
}));
